import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { Typography, Box } from '@mui/material';

const AppText = forwardRef(({
    text,
    variant = 'body1',
    color = 'inherit',
    maxChars,
    component,
    sx = {},
    ...props
}, ref) => {
    const renderText = (content) => {
        if (maxChars && typeof content === 'string' && content.length > maxChars) {
            return `${content.substring(0, maxChars)}...`;
        }
        return content;
    };

    // Handle array of text items
    if (Array.isArray(text)) {
        return (
            <Box ref={ref} sx={{ ...sx }}>
                {text.map((item, index) => (
                    <Typography
                        key={index}
                        variant={variant}
                        color={color}
                        component={component}
                        gutterBottom={index < text.length - 1}
                        {...props}
                    >
                        {renderText(item)}
                    </Typography>
                ))}
            </Box>
        );
    }

    // Handle single text item
    return (
        <Typography
            ref={ref}
            variant={variant}
            color={color}
            component={component}
            sx={sx}
            {...props}
        >
            {renderText(text)}
        </Typography>
    );
});

AppText.propTypes = {
    text: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.arrayOf(PropTypes.string)
    ]).isRequired,
    variant: PropTypes.oneOf([
        'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
        'subtitle1', 'subtitle2',
        'body1', 'body2',
        'button', 'caption', 'overline'
    ]),
    color: PropTypes.string,
    maxChars: PropTypes.number,
    component: PropTypes.elementType,
    sx: PropTypes.object,
};

export default AppText;